module.exports = __webpack_public_path__ + "media/luxury-2026/formal-drone-c86edbfa.jpg";